const uniqueArray = array => array.filter((value, index, self) => self.indexOf(value) === index);

const extractListingDataLayerData = (yachtData, contacts, listName = null) => ({
  id: yachtData.id,
  brokerIds: uniqueArray(contacts.map(({ brokerId }) => brokerId)).join(','),
  builders: yachtData.builders,
  brokerNames: uniqueArray(contacts.map(({ brokerName }) => brokerName)).join(','),
  currency: yachtData.currency,
  listingType: yachtData.entity === 'yacht_for_charter' ? 'Yacht for Charter' : 'Yacht for Sale',
  listName,
  name: yachtData.name,
  price: yachtData.price,
  primaryCategory: yachtData.primaryCategory,
  promotionType: yachtData.promotionType
});

export default extractListingDataLayerData;
